import React from 'react';
import classNames from 'classnames';
import {
  useFloating,
  useInteractions,
  useDismiss,
  offset,
  flip,
  shift,
  size as sizeMiddleware,
  autoUpdate,
  FloatingPortal,
} from '@floating-ui/react';
import { useTreeSelectContext } from './context/tree-select-context';
import TreeSelectProvider from './provider/tree-select-provider';
import TreeSelectTrigger from './components/tree-select-trigger';
import TreeSelectList from './components/tree-select-list';

const TreeSelectLayout = () => {
  const { isOpen, closeDropdown, listboxId, size, invalid, disabled } = useTreeSelectContext();

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: (open) => {
      if (!open) closeDropdown();
    },
    placement: 'bottom-start',
    middleware: [
      offset(4),
      flip(),
      shift(),
      sizeMiddleware({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`,
            zIndex: 1001,
          });
        },
      }),
    ],
    whileElementsMounted: autoUpdate,
  });

  const dismiss = useDismiss(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss]);

  const rootClasses = classNames('ws-ui-tree-select', `ws-ui-tree-select--${size}`, {
    'ws-ui-tree-select--is-invalid': invalid,
    'ws-ui-tree-select--is-open': isOpen,
    'ws-ui-tree-select--is-disabled': disabled,
  });

  return (
    <div className={rootClasses}>
      <div ref={refs.setReference} {...getReferenceProps()}>
        <TreeSelectTrigger />
      </div>
      {isOpen && (
        <FloatingPortal>
          <div ref={refs.setFloating} id={listboxId} style={floatingStyles} {...getFloatingProps()}>
            <TreeSelectList />
          </div>
        </FloatingPortal>
      )}
    </div>
  );
};

const TreeSelect = (props) => (
  <TreeSelectProvider {...props}>
    <TreeSelectLayout />
  </TreeSelectProvider>
);

export default TreeSelect;
